import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import DebugPage from 'pages/Debug';
import { isDebugEnabled } from 'components/Router/Helper';

// Stores / Actions
import { fetchAuthenticatedPerson } from 'store/authentication';

interface Props {
  authentication: any;
  authStatus: any;
  children: () => any;
}

function AuthFetch(props: Props) {
  const { authentication, authStatus, children } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAuthenticatedPerson());
  }, []);

  if (_get(authentication.person, 'account.isAdmin') === false || authStatus.hasError()) {
    if (isDebugEnabled()) {
      return <DebugPage />;
    } else {
      window.location = authentication.api.login;
    }
  }

  return authStatus.isNormal() ? children() : null;
}

export default AuthFetch;
